import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  wrapper: {
    position: 'relative',
    padding: '7px',
    '& > div:hover': {
      backgroundColor: '#eeeeee',
      cursor: 'pointer'
    },
    height: 40
  },
  text: (styles) => ({
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 16,
    color: '#555',
    outline: styles.selected ? 'dashed 2px grey' : 'none',
    backgroundImage: 'linear-gradient(135deg, #999 25%, transparent 25%, transparent 50%, #999 50%, #999 75%, transparent 75%, #fff)',
    backgroundSize: '25px 25px'
  })
})

export default function HotkeySpacer (props) {
  const {
    id,
    onClick,
    selected = false
  } = props

  const classes = useStyles({ selected })

  const pixelWidth = 12 * 43

  // the flex="none" is key to the specified widths being used but still allowing us to use the other flexbox alignments, wrapping etc.
  return (
    <Box
      className={classes.wrapper}
      width={pixelWidth}
      flex="none"
      onClick={(event) => onClick(event, id)}
      display="flex"
    >
      <Box flex={1} display="flex" className={classes.text} justifyContent="center" alignItems="center">SPACER - blank space on POS</Box>
    </Box>
  )
}

HotkeySpacer.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool
}
